import $ from 'jquery';  // Import jQuery

// Expose jQuery globally if needed
if (typeof window !== 'undefined') {
  window.$ = window.jQuery = $;  // Ensure jQuery is available globally for your plugin
}

(function ($) {
  $.fn.accordionPlugin = function (options) {
    const settings = $.extend(
      {
        animationSpeed: 300, // Speed of slideUp/slideDown animations
        initialOpen: null, // Optional ID to open on load
      },
      options
    );

    function getHash() {
      return window.location.hash.substring(1);
    }

    return this.each(function () {
      const accordion = $(this);

      const $allAccordions = $(".accordion");
      const $tabs = accordion.children("dt");
      const $panels = accordion.children("dd");

      function closeAllPanels() {
        $allAccordions.find("dt").removeClass("accordion-active").attr("aria-expanded", false);
        $allAccordions.find("dd").removeClass("active").hide().attr("aria-hidden", true);
      }

      // Function to open a specific tab by ID
      function openTabById(id) {
        const $targetTab = accordion.find(`#${id}`);
        const $targetPanel = $targetTab.next("dd");

        if ($targetTab.length && $targetPanel.length) {
          // Close all panels
          closeAllPanels();

          // Open the target panel
          $targetTab.addClass("accordion-active").attr("aria-expanded", true);
          $targetPanel.addClass("active").show().attr("aria-hidden", false);

          // Calculate header height and announcement banner height for offset
          const announcementBannerHeight = $(".announcement-banner").outerHeight() || 0;
          const headerHeight = $("header").outerHeight() || 100;
          const offsetTop = announcementBannerHeight + headerHeight;

          // Scroll to the target tab
          $("html, body").animate(
            {
              scrollTop: $targetTab.offset().top - offsetTop,
            },
            300
          );
        }
      }

      accordion.on("click", "dt", function () {
        const $this = $(this);
        const $target = $this.next("dd");

        if (!$this.hasClass("accordion-active")) {
          closeAllPanels();

          // Open the clicked panel
          $this.addClass("accordion-active").attr("aria-expanded", true);
          $target.addClass("active").slideDown(settings.animationSpeed).attr("aria-hidden", false);

          // Calculate header height and announcement banner height for offset
          const announcementBannerHeight = $(".announcement-banner").outerHeight() || 0;
          const headerHeight = $("header").outerHeight() || 100;
          const offsetTop = announcementBannerHeight + headerHeight;

          // Scroll to the clicked tab
          $("html, body").animate(
            {
              scrollTop: $this.offset().top - offsetTop,
            },
            300
          );
        } else {
          $this.removeClass("accordion-active").attr("aria-expanded", false);
          $target.removeClass("active").slideUp(settings.animationSpeed).attr("aria-hidden", true);
        }
        return false;
      });

      accordion.on("keypress", "dt", function (event) {
        if (event.which === 13 || event.which === 32) {
          $(this).trigger("click");
          return false;
        }
      });

      // On page load, check for an initial tab to open
      const initialHash = getHash();
      if (initialHash) {
        openTabById(initialHash);
      } else if (settings.initialOpen) {
        openTabById(settings.initialOpen);
      }

      // Listen for hash changes dynamically
      let hashTimeout;
      $(window).on("hashchange", function () {
        clearTimeout(hashTimeout);
        hashTimeout = setTimeout(() => {
          const newHash = getHash();
          if (newHash) {
            openTabById(newHash);
          }
        }, 100);
      });

      // Handle anchor links inside accordion
      accordion.find("a[href^='#']").on("click", function (event) {
        const targetHash = $(this).attr("href").substring(1);
        const $targetTab = accordion.find(`#${targetHash}`);
        if ($targetTab.length) {
          event.preventDefault(); // Prevent default scrolling behavior
          openTabById(targetHash);
        }
      });

      // Add ARIA attributes for accessibility
      $tabs.each(function () {
        const $this = $(this);
        const isActive = $this.hasClass("accordion-active");
        $this.attr("aria-expanded", isActive);
      });

      $panels.each(function () {
        const $this = $(this);
        const isActive = $this.hasClass("active");
        $this.attr("aria-hidden", !isActive);
      });
    });
  };
})(window.jQuery);

// Trigger policyUpdated event to initialize the accordion when updated
document.addEventListener("policyUpdated", function () {
  // Initialize Accordion
  $(".accordion").accordionPlugin();

  // Scroll to correct privacy policy anchor if there's a hash in the URL
  var hash = window.location.hash.substring(1);
  if (hash) {
    var $target = $("#" + hash);
    if ($target.length) {
      // Calculate header and banner heights for offset
      const announcementBannerHeight = $(".announcement-banner").outerHeight() || 0;
      const headerHeight = $("header").outerHeight() || 100;
      const offsetTop = announcementBannerHeight + headerHeight;

      $("html, body").animate(
        { scrollTop: $target.offset().top - offsetTop },
        0
      );
    }
  }
});

// Privacy toggle and DSAR request
$(document).on("click", ".privacy-center-toggle", function (event) {
  event.preventDefault();
  window.ketch("showPreferences", {
    tab: "consentsTab",
    dataSubjectTypeCodes: ["customer", "other"],
    showOverviewTab: true,
    showConsentsTab: true,
    showRightsTab: true,
    showSubscriptionsTab: false,
  });
});

$(document).on("click", ".dsar-request", function (event) {
  event.preventDefault();
  window.ketch("showPreferences", {
    tab: "rightsTab",
    dataSubjectTypeCodes: ["customer", "other"],
    showOverviewTab: true,
    showConsentsTab: true,
    showRightsTab: true,
    showSubscriptionsTab: false,
  });
});
